const items = [
  "Agréé toutes assurances",
  "Aucune avance de frais",
  "Déplacement à domicile gratuit",
  "Intervention rapide & propre",
  "Jusqu'à 200€ offerts*",
  "Vitres de qualité d'origine",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#D4AF37]/20 bg-[#0A0A0C] py-5">
    <div className="flex w-max animate-marquee items-center whitespace-nowrap">
      {[...items, ...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-xl uppercase tracking-[0.2em] text-zinc-400">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
        </span>
      ))}
    </div>
  </div>
);
